import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { AboutEditorView } from "./AboutEditorView";
// Draft About editor used during collection creation — no backend yet. Texts
// and staged image Files live in the wizard; here we only render the live page
// preview and build local object-URL previews for the staged images. The wizard
// flushes everything (PUT about + per-block/slot image uploads) once the
// collection is created and has an id.
export var AboutDraftEditor = function (_a) {
    var texts = _a.texts, onTextsChange = _a.onTextsChange, blockFiles = _a.blockFiles, onBlockFile = _a.onBlockFile, slotFiles = _a.slotFiles, onSlotFile = _a.onSlotFile;
    var _b = useState([null, null, null, null, null, null]), urls = _b[0], setUrls = _b[1];
    // Indices: 0 block2, 1 block3, 2 block4, 3 slot1, 4 slot2, 5 slot3.
    useEffect(function () {
        var files = [
            blockFiles.block2,
            blockFiles.block3,
            blockFiles.block4,
            slotFiles[0],
            slotFiles[1],
            slotFiles[2],
        ];
        var next = files.map(function (f) { return (f ? URL.createObjectURL(f) : null); });
        setUrls(next);
        return function () { return next.forEach(function (u) { return u && URL.revokeObjectURL(u); }); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [blockFiles.block2, blockFiles.block3, blockFiles.block4, slotFiles[0], slotFiles[1], slotFiles[2]]);
    var blockUrl = {
        block2: urls[0],
        block3: urls[1],
        block4: urls[2],
    };
    return (_jsx(AboutEditorView, { value: texts, onChange: onTextsChange, getBlockImage: function (key) { return ({ url: blockUrl[key], busy: false }); }, onUploadBlockImage: function (key, file) { return onBlockFile(key, file); }, onDeleteBlockImage: function (key) { return onBlockFile(key, null); }, getSlotImage: function (index) { return ({ url: urls[3 + index], busy: false }); }, onUploadSlot: function (index, file) { return onSlotFile(index, file); }, onDeleteSlot: function (index) { return onSlotFile(index, null); } }));
};
